const custom_profile_fields = {
    table: {
        add_button: 'Добавить поле профиля',
        title: {
            field_label: 'Название поля',
            type: 'Тип',
            user_data_key: 'Ключ пользовательских данных',
        },
        placeholder: {
            title: 'Сбор данных профиля',
            description: 'Настройте поля для сбора дополнительной информации о пользователе при регистрации.',
        },
    },
    type: {
        Text: 'Текст',
        Number: 'Число',
        Date: 'Дата',
        Checkbox: 'Флажок (Логическое значение)',
        Select: 'Выпадающий список (Одиночный выбор)',
        Url: 'URL',
        Regex: 'Регулярное выражение',
        Address: 'Адрес (Составной)',
        Fullname: 'Полное имя (Составное)',
    },
    modal: {
        title: 'Добавить поле профиля',
        subtitle: 'Настройте поля для сбора дополнительной информации о пользователе при регистрации.',
        built_in_properties: 'Базовые пользовательские данные',
        custom_properties: 'Пользовательские данные',
        custom_data_field_name: 'Ключ пользовательских данных',
        custom_data_field_input_placeholder: 'Введите ключ пользовательских данных, например `myFavoriteFieldName`',
        custom_field: {
            title: 'Пользовательские данные',
            description: 'Любые дополнительные свойства пользователя, которые вы можете определить для удовлетворения уникальных требований вашего приложения.',
        },
        type_required: 'Пожалуйста, выберите тип свойства',
        create_button: 'Создать поле профиля',
    },
    details: {
        page_title: 'Детали поля профиля',
        back_to_sie: 'Вернуться к процессу входа',
        enter_field_name: 'Введите название поля профиля',
        delete_description: 'Это действие нельзя отменить. Вы уверены, что хотите удалить это поле профиля?',
        field_deleted: 'Поле профиля {{name}} успешно удалено.',
        key: 'Ключ пользовательских данных',
        field_name: 'Название поля',
        field_type: 'Тип поля',
        settings: 'Настройки',
        settings_description: 'Настройте поля для сбора дополнительной информации о пользователе при регистрации.',
        address_format: 'Формат адреса',
        single_line_address: 'Адрес в одну строку',
        multi_line_address: 'Адрес в несколько строк (например, Улица, Город, Область, Индекс, Страна)',
        components: 'Компоненты',
        components_tip: 'Выберите компоненты для составления сложного поля.',
        label: 'Метка поля',
        label_placeholder: 'Метка',
        label_tip: 'Нужна локализация? Добавьте языки в <a>Процесс входа > Контент</a>',
        label_tooltip: 'Плавающая метка, описывающая назначение поля. Появляется внутри ввода и перемещается вверх, когда поле в фокусе или содержит значение.',
        placeholder: 'Заполнитель поля',
        placeholder_placeholder: 'Заполнитель',
        placeholder_tooltip: 'Пример или подсказка формата внутри поля. Обычно появляется после «всплытия» метки; должна быть короткой (напр.: ДД/ММ/ГГГГ).',
        description: 'Описание поля',
        description_placeholder: 'Описание',
        description_tooltip: 'Вспомогательный текст под полем. Используйте для более длинных инструкций или заметок по доступности.',
        options: 'Опции',
        options_tip: 'Введите каждую опцию с новой строки. Формат: value:label (например, red:Red). Можно указать только value; если label не задан, в качестве метки будет отображаться само value.',
        options_placeholder: 'value1:label1\nvalue2:label2\nvalue3:label3',
        regex: 'Регулярное выражение',
        regex_tip: 'Определите регулярное выражение для проверки ввода.',
        regex_placeholder: '^[a-zA-Z0-9]+$',
        date_format: 'Формат даты',
        date_format_us: 'MM/dd/yyyy (например, США)',
        date_format_uk: 'dd/MM/yyyy (например, Великобритания и Европа)',
        date_format_iso: 'yyyy-MM-dd (Международный стандарт)',
        custom_date_format: 'Пользовательский формат даты',
        custom_date_format_placeholder: 'Введите пользовательский формат даты. Например, "MM-dd-yyyy"',
        custom_date_format_tip: 'См. документацию <a>date-fns</a> для допустимых токенов форматирования.',
        input_length: 'Длина ввода',
        value_range: 'Диапазон значений',
        min: 'Минимум',
        max: 'Максимум',
        default_value: 'Значение по умолчанию',
        checkbox_checked: 'Выбрано (True)',
        checkbox_unchecked: 'Не выбрано (False)',
        required: 'Обязательно',
        required_description: 'Если включено, это поле должно быть заполнено пользователем. Если отключено, это поле необязательно.',
    },
};
export default Object.freeze(custom_profile_fields);
